export function splitByVisualWidth(str, maxWidth) {
    const parts = [];
    let current = '';
    let currentWidth = 0;
    for (let i = 0; i < str.length; i++) {
        const ch = str[i];
        const w = ch.charCodeAt(0) > 0xff ? 2 : 1;
        if (currentWidth + w > maxWidth) {
            parts.push(current);
            current = ch;
            currentWidth = w;
        } else {
            current += ch;
            currentWidth += w;
        }
    }
    if (current) parts.push(current);
    return parts;
}

/**
 * 获取字符串的视觉宽度（半角字符数）
 * @param {string} str
 * @returns {number}
 */
export function visualWidth(str) {
    let width = 0;
    for (let i = 0; i < str.length; i++) {
        const code = str.charCodeAt(i);
        // 全角字符（汉字、全角符号等）宽度为2
        width += code > 0xff ? 2 : 1;
    }
    return width;
}

/**
 * 将字符串填充到指定视觉宽度，并指定对齐方式
 * @param {string} str     原字符串
 * @param {number} width   目标宽度（半角字符数）
 * @param {'left'|'right'|'center'} align 对齐方式，默认 left
 * @returns {string}
 */
function padToWidth(str, width, align = 'left') {
    const curWidth = visualWidth(str);
    if (curWidth >= width) return str;
    const padCount = width - curWidth;
    const spaces = ' '.repeat(padCount);
    if (align === 'right') return spaces + str;
    if (align === 'center') {
        const left = Math.floor(padCount / 2);
        return ' '.repeat(left) + str + ' '.repeat(padCount - left);
    }
    // left
    return str + spaces;
}

// 便捷函数
export const leftAlign = (str, width) => padToWidth(str, width, 'left');
export const rightAlign = (str, width) => padToWidth(str, width, 'right');
export const centerAlign = (str, width) => padToWidth(str, width, 'center');